import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { ChangeDetectorRef, EventEmitter, Injectable, NgZone } from "@angular/core";
import { ArrowKeysOptions } from "src/app/_directives/ArrowKeysUseable.directive";
import { Attachment } from "src/app/_interfaces/Attachment";
import { HttpFunctionResult } from "src/app/_interfaces/HttpFunctionResult";
import { HttpService } from "src/app/_provider/http.service";

export interface EmailTag {
    firstName?: string
    lastName?: string,
    email: string,
    highlighted?: boolean
}

export interface EmailAddresses{
    id: number,
    firstName?: string,
    lastName?: string,
    email: string
}

@Injectable({
    providedIn: 'root'
})
export class EmailTags {

    public tags: EmailTag[] = []
    public emailAdresses: EmailAddresses[] = []
    
    public searchText: string = ""

    public focused: boolean = false

    public arrowKeysOptions: ArrowKeysOptions = {
        selectedItem: -1,
        mouseOverItem: new EventEmitter<number>(null),
        mouseMove: new EventEmitter<boolean>(null),
        clearSelectedItem: new EventEmitter<boolean>(null),
        enterPressed: (index: number) =>{
            if(!this.focused) return
            if(index == -1)this.addTag({firstName: '', lastName: '', email: this.searchText})
            else this.addTag(this.emailAdresses[index])
        }
    }

    public changeDetector: ChangeDetectorRef

    constructor(
        private http: HttpService
    ){}
    
    /**
     * Setzt den Fokus auf das E-Mail-Tag-Eingabefeld und lädt die E-Mail-Adressen.
     */
    public focus(){
        this.focused = true
        this.loadEmailAddresse()
    }
    
    /**
     * Lädt die E-Mail-Adressen.
     */
    public async loadEmailAddresse(){
        const res: HttpFunctionResult<EmailAddresses[]> = await this.http.GET<EmailAddresses[]>({
            path: `ticket/email/addresses?searchtext=${encodeURIComponent(this.searchText)}`
        })
        if(!res.success) return
        this.emailAdresses = res.data
        this.filterEmailList()
    }

    /**
     * Fügt ein E-Mail-Tag hinzu.
     * @param tag Das E-Mail-Tag, welches hinzugefügt werden soll.
     */
    public addTag(tag: EmailTag){
        if(!(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(tag.email))) return
        this.tags.push(tag)
        this.changeDetector.detectChanges()
        this.searchText = ""
        this.loadEmailAddresse()
    }

    /**
     * Entfernt ein E-Mail-Tag.
     * @param tag Das E-Mail-Tag, welches entfernt werden soll.
     */
    public deleteTag(tag: EmailTag){
        this.tags.splice(this.tags.indexOf(tag), 1);
    }

    /**
     * Filtert die E-Mail-Adressen, sodass bereits hinzugefügte E-Mail-Adressen nicht mehr angezeigt werden.
     */
    private filterEmailList(){
        this.emailAdresses = this.emailAdresses.filter(email => {
            if(this.tags.find(tag => tag.email == email.email)) return false
            return true
        })
        this.arrowKeysOptions.selectedItem = -1
    }

    private searchTimeout: any

    /**
     * Wird aufgerufen, wenn eine Taste gedrückt wird.
     * @param event Das Ereignis, welches das Drücken einer Taste ausgelöst hat.
     */
    public keyenterPressed(event: KeyboardEvent){

        if(!this.focused) return

        if(event.key == "ArrowUp" && this.arrowKeysOptions.selectedItem == 0){
            this.arrowKeysOptions.clearSelectedItem.emit(true)
            this.arrowKeysOptions.selectedItem = -1
        }
        
        if(event.key == "ArrowDown" || event.key == "ArrowUp" || event.key == "Enter") return event.preventDefault()

        this.searchTimeout = setTimeout(() => this.loadEmailAddresse(), 300)
    
        if(event.key == "Backspace") return this.backspacePressed()
        this.tags.forEach(tag => tag.highlighted = false)
        
    }

    /**
     * Wird aufgerufen, wenn die Backspace-Taste gedrückt wird.
     */
    public backspacePressed(){
        if(this.searchText == "" && this.tags.length > 0){
            if(this.tags[this.tags.length - 1]?.highlighted)
                this.tags.splice(this.tags.length - 1, 1)
            else this.tags[this.tags.length - 1].highlighted = true
        }
    }

    


}